import { SelectWithGroups } from 'client/javascript/select_with_groups';
import { localizeLink } from 'client/javascript/util/locale';
import { MemberCounter } from 'client/javascript/member_counter';
import { RESERVABLE_TYPE_TO_MESSAGE } from 'shared/util/constants';
import { handleSearchStickyBarIteration as pushMessageToAnalytic } from './analytics';
import { PDP_TEMPLATES } from './constants';

class SearchPanelMemberCounter extends MemberCounter {
  constructor({ interactionLabel, updateMinCapacity, onScroll }) {
    super({ interactionLabel, onScroll });
    this.updateMinCapacity = updateMinCapacity;
    this.updateMinCapacity(this.countOfTeam.innerHTML);
  }

  setPrice = minPrice => {
    if (minPrice !== undefined) {
      this.panelFilterPrice.innerHTML = minPrice;
    } else {
      this.panelFilterPrice.innerHTML = '-';
      this.updateMinCapacity(this.countOfTeam.innerHTML);
    }
  };

  static create(options) {
    return new SearchPanelMemberCounter(options);
  }
}

export class SearchStickyBar {
  constructor(productsDetailsData, onScroll) {
    this.panelButtonFilter = document.getElementById('panel_button_filter');
    if (this.panelButtonFilter) {
      this.productsDetailsData = productsDetailsData;
      this.updateClosestMarketId = productsDetailsData.updateClosestMarketId.bind(productsDetailsData);
      this.panelButtonCapacity = this.panelButtonFilter.querySelector('#js-panel-button__capacity');

      this.isPrice = true;
      this.countOfTeam = null;
      this.syncElement = null;
      this.panelSelect = null;

      this.panelSelect = SelectWithGroups.create({
        wrapperElement: this.panelButtonFilter,
        onSubmit: this.redirectToSearch.bind(this),
        onSelect: this.setLocationDependencies.bind(this),
        updateClosestMarketId: productsDetailsData.updateClosestMarketId.bind(this),
        syncElement: this.syncElement
      });

      this.membercounter = SearchPanelMemberCounter.create({
        interactionLabel: 'Product Page - Click Apply Capacity',
        updateMinCapacity: this.productsDetailsData.updateMinCapacity.bind(this.productsDetailsData),
        onScroll
      });

      this.countOfTeam = this.membercounter.countOfTeam.innerHTML;
    }
  }

  setLocationDependencies(id, minPrice, productName) {
    if (this.panelSelect) {
      this.updateClosestMarketId(id);
      this.panelSelect.set(id);
      this.setCapacityOfProduct(productName);
    }

    if (this.membercounter) {
      this.membercounter.setMarketId(id);
      this.membercounter.setPrice(minPrice);
    }

    if (!this.isPrice) {
      this.setPriceMessageStyles();
    }
  }

  setCapacityOfProduct = priceApiProductName => {
    if (this.panelButtonCapacity && priceApiProductName) {
      this.productName = RESERVABLE_TYPE_TO_MESSAGE[priceApiProductName];
      this.membercounter.maxCapacity = this.panelButtonCapacity.dataset.productCapacity;
    }
  };

  setPriceMessageStyles = () => {
    document.querySelector('.panel-filter__price').classList.add('panel-filter__price-message');
  };

  redirectToSearch = (event, data) => {
    if (event) {
      event.preventDefault();
    }

    const { shouldUseWorkspaceFilter } = this.panelButtonFilter.dataset;
    const urlSearchParam = new URLSearchParams();

    urlSearchParam.append('slug', data.value.replace('/l/', ''));
    urlSearchParam.append('capacity', this.membercounter.countOfTeam.innerHTML);

    if (shouldUseWorkspaceFilter === 'true') {
      urlSearchParam.append(PDP_TEMPLATES.WORKSPACE, this.productName);
    }

    const searchPageUrl = localizeLink({ to: `search?${urlSearchParam.toString()}` });

    pushMessageToAnalytic(searchPageUrl);
    window.location.href = searchPageUrl;
  };

  setPrice(currentProductData = {}, productName) {
    const { minPrice, isPrice = false } = currentProductData;

    if (this.panelButtonFilter && minPrice) {
      this.setLocationDependencies(this.productsDetailsData.closestMarketId, minPrice, productName);
    }

    this.isPrice = isPrice;
  }
}
